import { PiletScopedLogger } from '@sharefiledev/sharefile-appshell';

const loggerNotSetUp = () => {
	throw new Error('Logger not set up');
};

let logger: PiletScopedLogger = {
	logError: loggerNotSetUp,
	logInfo: loggerNotSetUp,
	setLoggingTags: loggerNotSetUp,
};

export function setLogger(piletLogger: PiletScopedLogger) {
	logger = piletLogger;
}

export function getLogger() {
	return logger;
}
